import type { SerializedError } from "@reduxjs/toolkit";
import type { FetchBaseQueryError } from "@reduxjs/toolkit/query";

import type ErrorResponse from "./ErrorResponse";

export interface FetchBaseQueryAlertProps {
	error: FetchBaseQueryError | SerializedError;
	title?: string;
}

export const FetchBaseQueryAlert = ({
	error,
	title,
}: FetchBaseQueryAlertProps) => {
	if (error.hasOwnProperty("message")) {
		return (
			<div className="alert">
				{title} {(error as SerializedError).message}
			</div>
		);
	}

	const errorData = (error as FetchBaseQueryError).data;

	if (errorData) {
		const message = (errorData as ErrorResponse).message;

		if (message) {
			return (
				<div className="alert">
					<h3>{title}</h3>
					{(errorData as ErrorResponse).message}
				</div>
			);
		}
	}

	if ('error' in error && error.error) {
		return (
			<div className="alert">
				<h3>{title}</h3>
				{error.error}
			</div>
		);
	}

	return (
		<div className="alert">
			<h3>{title}</h3>
		</div>
	);
};

export default FetchBaseQueryAlert;
